import axios from "axios";
import http from "http";
import https from "https";

import { serverConfig } from "shared/data/configs/server";

import type { AiSeoOverride, AiSeoSuggestionResponse } from "./types";
const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

const stripHtml = (value: string) => value.replaceAll(/<[^>]*>/g, "").trim();

const instance = axios.create({
  httpAgent: new http.Agent({ keepAlive: true }),
  httpsAgent: new https.Agent({ keepAlive: true }),
});

export const fetchAiSeoSuggestion = async (
  entityUuid: string,
): Promise<AiSeoOverride | undefined> => {
  const { host, timeoutMs } = serverConfig.aiSeo;

  if (!host) {
    return undefined;
  }

  if (!uuidRegex.test(entityUuid)) {
    return undefined;
  }

  const url = `${host}/v1/seo/suggestions/${encodeURIComponent(entityUuid)}`;

  try {
    const response = await instance.get<AiSeoSuggestionResponse>(url, { timeout: timeoutMs });
    const data = response.data;

    if (data.status !== "completed") {
      return undefined;
    }

    const keywords = data.ai_keywords?.map(k => stripHtml(k)).filter(Boolean) ?? [];

    if (keywords.length === 0) {
      return undefined;
    }

    return {
      keywords: keywords.join(","),
    };
  } catch {
    return undefined;
  }
};
